module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-col', {
    staticClass: "mb-3",
    attrs: {
      "md": "12"
    }
  }, [_c('b-card', {
    staticClass: "formCardDash"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h6', {
    staticClass: "card-title mb-0"
  }, [_vm._v("Enquiry Details")])]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped table-sm"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Enquiry No")]), _vm._v(" "), _c('th', [_vm._v("Enquiry Date")]), _vm._v(" "), _c('th', [_vm._v("Branch")]), _vm._v(" "), _c('th', [_vm._v("Sales Person")]), _vm._v(" "), _c('th', [_vm._v("Client Name")]), _vm._v(" "), _c('th', [_vm._v("Shipping Line")]), _vm._v(" "), _c('th', [_vm._v("POR")]), _vm._v(" "), _c('th', [_vm._v("POL")]), _vm._v(" "), _c('th', [_vm._v("POD")]), _vm._v(" "), _c('th', [_vm._v("Incoterm")]), _vm._v(" "), _c('th', [_vm._v("FCL/LCL")]), _vm._v(" "), _c('th', [_vm._v("Status")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.enquiryData), function(enquiry, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(enquiry.enquiryNo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(enquiry.enquiryDate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(enquiry.branchName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(enquiry.salesPerson))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(enquiry.clientName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(enquiry.shippingLine))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(enquiry.por))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(enquiry.pol))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(enquiry.pod))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(enquiry.incoterm))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(enquiry.fclLcl))]), _vm._v(" "), _c('td', [_c('b-badge', {
      attrs: {
        "variant": enquiry.status === 'Converted' ?
          'success' :
          enquiry.status === 'Pending' ?
          'warning' :
          'secondary'
      }
    }, [_vm._v(_vm._s(enquiry.status))])], 1)])
  }), _vm._v(" "), (_vm.enquiryData.length === 0) ? _c('tr', [_c('td', {
    staticClass: "text-center text-muted",
    attrs: {
      "colspan": "12"
    }
  }, [_vm._v("\n                No data available\n              ")])]) : _vm._e()], 2)])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b56cb19","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/dashboard/salesPersonDashboard/EnquirySection.vue
// module id = 2663
// module chunks = 0